import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { api } from "../lib/api";
import BookingsTable from "../components/admin/BookingsTable";
import SlotManager from "../components/admin/SlotManager";
import SettingsPanel from "../components/admin/SettingsPanel";

export default function AdminDashboard() {
  const nav = useNavigate();
  const [stats, setStats] = useState(null);
  const loadStats = useCallback(() => api.get("/admin/stats").then(r => setStats(r.data)).catch(e => {
    if (e?.response?.status === 401) { localStorage.removeItem("admin_token"); nav("/admin/login"); }
  }), [nav]);
  useEffect(() => { loadStats(); }, [loadStats]);

  const logout = () => { localStorage.removeItem("admin_token"); nav("/admin/login"); };
  const cards = stats ? [["Upcoming", stats.upcoming], ["Awaiting reports", stats.pending_reports], ["Completed", stats.completed], ["Cancelled", stats.cancelled]] : [];

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-10">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-serif text-slate-900">Clinic dashboard</h1>
          <Button variant="outline" onClick={logout} className="rounded-full" data-testid="admin-logout-btn"><LogOut className="w-4 h-4 mr-2" />Sign out</Button>
        </div>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
          {cards.map(([k, v]) => (
            <div key={k} className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`stat-${k.toLowerCase().replace(" ", "-")}`}>
              <div className="text-xs uppercase tracking-wider text-slate-500">{k}</div>
              <div className="mt-2 text-3xl font-serif text-slate-900">{v}</div>
            </div>
          ))}
        </div>
        <Tabs defaultValue="bookings" className="mt-10">
          <TabsList>
            <TabsTrigger value="bookings" data-testid="tab-bookings">Bookings</TabsTrigger>
            <TabsTrigger value="slots" data-testid="tab-slots">Slots</TabsTrigger>
            <TabsTrigger value="settings" data-testid="tab-settings">Settings</TabsTrigger>
          </TabsList>
          <TabsContent value="bookings"><BookingsTable onChange={loadStats} /></TabsContent>
          <TabsContent value="slots"><SlotManager /></TabsContent>
          <TabsContent value="settings"><SettingsPanel /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
